// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"EmptyPlaceHolder_innerWrapper__NVZF6","heading":"EmptyPlaceHolder_heading__77kBE","button":"EmptyPlaceHolder_button__Oeb3d"};